import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import DeviceAppearanceNew from 'client/components/core/Sidebar/components/Settings/options/DeviceAppearance/DeviceAppearanceNew'
import HtmlAttrId from 'client/components/core/Sidebar/components/Settings/options/HtmlAttrId'
import { useDeviceModeContext } from 'client/context/DeviceModeContext'
import { FacebookCommentsInterface } from 'common/types/entities/FacebookCommentsInterface'
import React from 'react'
import { SizeAndPositionGroup } from 'src/editor/shared/settings/groups/size-and-position'
import { RangeElement } from 'src/editor/shared/ui-lib/range-element'
import Input from '../components/Input/Input'
import { DelayOption } from '../options'

interface FacebookCommentsSettingsProps {
  entity: FacebookCommentsInterface
  defaultEntity?: FacebookCommentsInterface
}

const FacebookCommentsSettings = ({
  entity,
  defaultEntity,
}: FacebookCommentsSettingsProps) => {
  const updateProp = useUpdateProp(entity)

  const { isMobile } = useDeviceModeContext()

  return (
    <>
      <RangeElement
        onChange={updateProp('numPosts')}
        value={entity.numPosts}
        label={'entity_settings.fb_comments.number_of_posts.label'}
      />
      <Input
        placeholder=""
        type={'text'}
        update={updateProp('href')}
        value={entity.href}
        label={'entity_settings.fb_comments.comment_url.label'}
        helpMessage={'entity_settings.fb_comments.help_message'}
      />
      <DelayOption update={updateProp('delay')} delay={entity.delay || 0} />
      <SizeAndPositionGroup
        margin={isMobile ? entity.mobileMargin : entity.margin}
        defaultMargin={
          isMobile ? defaultEntity?.mobileMargin : defaultEntity?.margin
        }
        updateMargin={updateProp(isMobile ? 'mobileMargin' : 'margin')}
      />
      <DeviceAppearanceNew entity={entity} />
      <HtmlAttrId attrId={entity.htmlAttrId} />
    </>
  )
}

export default FacebookCommentsSettings
